import { Injectable } from "@angular/core";
import { OneWayQuoteModel } from "./oneway-quote";
import { RequestApiService } from "src/app/services/domain_code/request-api.service";
import { TermsAndConditionsModel } from "src/app/models/common/terms-and-conditions.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { take } from "rxjs";
import { WarningBoxComponent } from "src/app/components/dialog-box/warning-box/warning-box.component";
import { MatDialog } from "@angular/material/dialog";

@Injectable({
    providedIn: 'root'
})

export class OneWayQuoteTableService {

    baseQuote: OneWayQuoteModel;
    disableSaveButton: boolean = false;

    termsAndCondition: TermsAndConditionsModel;
    termsConditionList: TermsAndConditionsModel[] = [];
    selectedTermsAndCondition: string = '';

    chargeMasterValidated: boolean = true;
    quoteChargeMasterValidated: boolean = true;

    constructor(private snackBar: MatSnackBar,
        private requestService: RequestApiService,
        private dialog: MatDialog) {
    }

    saveQuotation() {
        this.disableSaveButton = true;
        this.chargeMasterValidated = true;
        this.quoteChargeMasterValidated = true;
        this.baseQuote.terms_and_condition_fk = this.termsAndCondition;
        this.baseQuote.terms_and_condition_text = this.selectedTermsAndCondition;
        this.baseQuote.request = this.requestService.selectedRequest.id;

        let skipSave = false;

        if (this.baseQuote.ad_hoc_charges.length != 0) {
            this.baseQuote.ad_hoc_charges.map(charge => {
                if (charge.amount == null || charge.amount_currency == null || charge.quote_charge == null)
                    this.chargeMasterValidated = false;
            });

            for (let i = 0; i < this.baseQuote.ad_hoc_charges.length; i++) {
                for (let k = i + 1; k < this.baseQuote.ad_hoc_charges.length; k++) {
                    if (this.baseQuote.ad_hoc_charges[i]?.quote_charge.id == this.baseQuote.ad_hoc_charges[k]?.quote_charge.id) {
                        this.openWarningDialog('Duplicate Request Quote Ad-hoc charge entries', '', 'Ok');
                        this.disableSaveButton = false;
                        skipSave = true;
                    }
                }
            }
        }

        if (!this.chargeMasterValidated) {
            this.disableSaveButton = false;
            this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
            skipSave = true;
        }

        this.baseQuote.quote_items.map(quote => {
            if (quote.ad_hoc_charges.length != 0) {
                quote.ad_hoc_charges.map(charge => {
                    if (charge.amount == null || charge.amount_currency == null || charge.quote_charge == null)
                        this.quoteChargeMasterValidated = false;
                });

                for (let i = 0; i < quote.ad_hoc_charges.length; i++) {
                    for (let k = i + 1; k < quote.ad_hoc_charges.length; k++) {
                        if (quote.ad_hoc_charges[i]?.quote_charge.id == quote.ad_hoc_charges[k]?.quote_charge.id) {
                            this.openWarningDialog('Duplicate Ad-hoc charge entries', '', 'Ok');
                            this.disableSaveButton = false;
                            skipSave = true;
                            return;
                        }
                    }
                }
            }
        });

        if (!this.quoteChargeMasterValidated) {
            this.disableSaveButton = false;
            this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
            skipSave = true;
        }

        return new Promise((resolve, reject) => {
            if (skipSave) {
                reject('Ad-hoc charges error')
            } else {
                this.requestService.postQuotations(this.baseQuote.getOneWayQuoteSavePayload()).pipe(take(1)).subscribe({
                    next: res => {
                        this.snackBar.open('Quotation saved', 'Close', {
                            verticalPosition: 'top',
                            duration: 3000,
                        });
                        resolve(res);
                        this.disableSaveButton = false;
                        return res;
                    },
                    error: err => {
                        this.disableSaveButton = false;
                        reject(err);
                        if (err.status >= 500) {
                            this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                                verticalPosition: 'top',
                                duration: 5000,
                            });
                            return err;
                        } else if (err.status > 399 && err.status < 500) {
                            this.baseQuote.error.patchErrors(err.error);
                            return err;
                        }
                    }
                });
            }
        });
    }

    confirmBooking() {
        this.disableSaveButton = true;
        this.chargeMasterValidated = true;
        this.quoteChargeMasterValidated = true;
        this.baseQuote.terms_and_condition_fk = this.termsAndCondition;
        this.baseQuote.terms_and_condition_text = this.selectedTermsAndCondition;
        this.baseQuote.request = this.requestService.selectedRequest.id;
        this.baseQuote.insurance_premium = this.baseQuote.insurance_premium==null ? 0 :this.baseQuote.insurance_premium ;


        let skipSave = false;

        if (this.baseQuote.ad_hoc_charges.length != 0) {
            this.baseQuote.ad_hoc_charges.map(charge => {
                if (charge.amount == null || charge.amount_currency == null || charge.quote_charge == null)
                    this.chargeMasterValidated = false;
            });

            for (let i = 0; i < this.baseQuote.ad_hoc_charges.length; i++) {
                for (let k = i + 1; k < this.baseQuote.ad_hoc_charges.length; k++) {
                    if (this.baseQuote.ad_hoc_charges[i]?.quote_charge.id == this.baseQuote.ad_hoc_charges[k]?.quote_charge.id) {
                        this.openWarningDialog('Duplicate Request Quote Ad-hoc charge entries', '', 'Ok');
                        this.disableSaveButton = false;
                        skipSave = true;
                    }
                }
            }
        }

        if (!this.chargeMasterValidated) {
            this.disableSaveButton = false;
            this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
            skipSave = true;
        }

        this.baseQuote.quote_items.map(quote => {
            if (quote.ad_hoc_charges.length != 0) {
                quote.ad_hoc_charges.map(charge => {
                    if (charge.amount == null || charge.amount_currency == null || charge.quote_charge == null)
                        this.quoteChargeMasterValidated = false;
                });

                for (let i = 0; i < quote.ad_hoc_charges.length; i++) {
                    for (let k = i + 1; k < quote.ad_hoc_charges.length; k++) {
                        if (quote.ad_hoc_charges[i]?.quote_charge.id == quote.ad_hoc_charges[k]?.quote_charge.id) {
                            this.openWarningDialog('Duplicate Ad-hoc charge entries', '', 'Ok');
                            this.disableSaveButton = false;
                            skipSave = true;
                            return;
                        }
                    }
                }
            }
        });

        if (!this.quoteChargeMasterValidated) {
            this.disableSaveButton = false;
            this.openWarningDialog('Please select charge and enter all details', '', 'Ok');
            skipSave = true;
        }

        return new Promise((resolve, reject) => {
            if (skipSave) {
                reject('Ad-hoc charges error')
            } else {
                this.requestService.confirmLeaseBooking(this.baseQuote.getOneWayQuoteSavePayload()).pipe(take(1)).subscribe({
                    next: res => {
                        this.snackBar.open('Booking Confirmed', 'Close', {
                            verticalPosition: 'top',
                            duration: 3000,
                        });
                        resolve(res);
                        this.disableSaveButton = false;
                        return res;
                    },
                    error: err => {
                        this.disableSaveButton = false;
                        reject(err);
                        if (err.status >= 500) {
                            this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                                verticalPosition: 'top',
                                duration: 5000,
                            });
                            return err;
                        } else if (err.status > 399 && err.status < 500) {
                            this.baseQuote.error.patchErrors(err.error);
                            return err;
                        }
                    }
                });
            }
        });
    }

    openWarningDialog(label: string, description, action1: string, action2?: string, action3: string = null) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2, label3: action3 }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
            }
        })
    }
}